import {
  RaisedButton,
  FontIcon,
  Paper,
} from 'material-ui';
import React, { Component, PropTypes } from 'react';

class OptionsPartnerFinder extends Component {

  _startSearchingClicked = (e) => {
    const { history } = this.props;
    e.preventDefault();
    history.push('/partner-finder/results');
  };

  _addConnectionsClicked = (e) => {
    const { history } = this.props;
    e.preventDefault();
    history.push('/connections/add-connections');
  };

  render() {
    const { connectionsStats, history } = this.props;
    if (!connectionsStats.shouldShow) {
      window.dataLayer.push({
        event: 'TRACK_EVENT',
        ev: {
          category: 'Connections',
          action: 'Clicks from AppBar',
        },
      });
      history.push('/connections');
      return false;
    }
    const styles = {
      buttonFontIcon: {
        height: '100%',
        display: 'inline-block',
        verticalAlign: 'middle',
        float: 'left',
        paddingLeft: '12px',
        lineHeight: '36px',
      },
      canvasPaper: {
        width: '100%',
        margin: '32px auto',
        padding: '20px',
        textAlign: 'center',
      },
      leftDiv: {
        width: '40%',
        display: 'inline-block',
        marginLeft: '5%',
        float: 'left',
        textAlign: 'center',
      },
      rightDiv: {
        width: '40%',
        display: 'inline-block',
        marginLeft: '5%',
        textAlign: 'center',
      },
      button: {
        marginTop: '10px',
        width: '205px',
      },
      paper: {
        margin: '20px auto',
        height: '245px',
      },
      paperTitle: {
        borderBottom: '1px solid #efefef',
        backgroundColor: '#fbfbfb',
        padding: '15px',
        fontSize: '20px',
        fontWeight: '500',
      },
      paperBody: { margin: '20px 20px 0 40px', height: '105px', textAlign: 'left' },
    };

    const { findNewPartnersBodyText, findNewPartnersButton } = (() => {
      return {
        findNewPartnersBodyText: 'Search our growing network for the perfect partnership.',
        findNewPartnersButton: <RaisedButton onClick={this._startSearchingClicked} label="start searching" secondary style={styles.button}/>,
      };
    })();
    return (
      <div className="l-app-content">
      <div style={styles.canvasPaper}>
        <div style={styles.leftDiv}>
          <FontIcon className="tc-icon-person_add" color="rgba(0, 0, 0, 0.54)" style={{ fontSize: '64px' }} />
          <Paper style={styles.paper}>
            <div style={styles.paperTitle}>
              {"Add Existing Partners"}
            </div>
            <div style={styles.paperBody}>
              {"Manage all of your travel trade partners in one place."}
              <br />
              <FontIcon className="tc-icon-add" color="#00bcd4" style={{ top: '2px', fontSize: '16px', marginRight: '10px', marginTop: '10px' }}/>{"Get Up-to-Date Contacts"}
              <br />
              <FontIcon className="tc-icon-add" color="#00bcd4" style={{ top: '2px', fontSize: '16px', marginRight: '10px' }} />{"Exchange Rates"}
              <br />
              <FontIcon className="tc-icon-add" color="#00bcd4" style={{ top: '2px', fontSize: '16px', marginRight: '10px' }} />{"Message with Partners ("}<i>{"coming soon"}</i>{")"}
            </div>
            <RaisedButton onClick={this._addConnectionsClicked} label="Add Connections" style={styles.button} primary >
              <FontIcon className="tc-icon-add" style={styles.buttonFontIcon} color="white" />
            </RaisedButton>
          </Paper>
        </div>
        <div style={styles.rightDiv}>
          <FontIcon className="tc-icon-search" color="rgba(0, 0, 0, 0.54)" style={{ fontSize: '64px' }} />
          <Paper style={styles.paper}>
            <div style={styles.paperTitle}>
              {"Find New Partners"}
            </div>
            <div style={styles.paperBody}>
              {findNewPartnersBodyText}
            </div>
            {findNewPartnersButton}
          </Paper>
        </div>
      </div>
      </div>
    );
  }
}

OptionsPartnerFinder.propTypes = {
  history: PropTypes.object,
  user: PropTypes.object,
  connectionsStats: PropTypes.object,
};

export default OptionsPartnerFinder;



// WEBPACK FOOTER //
// ./src/app/components/connections/options-partnerFinder.jsx